import React from "react";
import themePropTypes from "../theme-prop-types";

const Image = ({ altText, iconsSize, image, params }) => {
  /**
   * IMPORTANT !!!
   * To make sure that your asset will be rendered on screen you must:
   *  - add asset in iconSet or defaulIconSet where [key -> 'asset_name']: value -> the reference to imported asset
   *  - asset name must be with underscore for example 'asset_name.svg', cuz obj[key] can't be created with dash, only can be with underscore or camelCase
   */
  const ariaLabelText = altText;

  return (
    <div
      aria-label={ariaLabelText}
      role={ariaLabelText ? "img" : null}
      className={`
        icon-web-sdk
        ${image}
        ${iconsSize ? `size-${iconsSize}` : ""}
        ${params ? params.split("|").join(" ") : ""}
      `}
    />
  );
};

Image.propTypes = themePropTypes.image;

export default Image;
